export {default} from "./lastSlide";
